export type Lang = 'en' | 'fr' | 'uk' | 'ru'

type AppConfig = {
  APP_NAME: string
  SUB_NAME?: string
  ALLOWED_LANGUAGES: Lang[]
  orderPlaylistPreferences: {
    motherLanguage: string
  }
  DEFAULT_LANGUAGE: Lang
  PRIVACY_POLICY_URL: string
  CONTACTS_NAME: string
  CONTACTS_CODE: string
  CONTACTS_TEL: string
  Identifier: string
}

const scaling: Record<'fr' | 'ua', AppConfig> = {
  fr: {
    APP_NAME: 'MusicTMM',
    SUB_NAME: 'Universum',
    ALLOWED_LANGUAGES: ['en', 'fr'],
    DEFAULT_LANGUAGE: 'fr',
    orderPlaylistPreferences: {
      motherLanguage: 'French',
    },
    PRIVACY_POLICY_URL: 'https://backoffice.fr.musictmm.com/privacy-policy.html',
    CONTACTS_NAME: 'MUSIC-TMM SAS',
    CONTACTS_CODE: '938 226 388',
    CONTACTS_TEL: '+33 6 88 66 09 30',
    Identifier: 'SIRET',
  },
  ua: {
    APP_NAME: 'MusicTMM',
    ALLOWED_LANGUAGES: ['en', 'fr', 'uk'],
    DEFAULT_LANGUAGE: 'en',
    orderPlaylistPreferences: {
      motherLanguage: 'Ukrainian',
    },
    PRIVACY_POLICY_URL: 'https://musictmm.com/privacy-policy.html',
    CONTACTS_NAME: 'ТОВ "ТММ-Юкрейн"',
    CONTACTS_CODE: '12345678',
    CONTACTS_TEL: '+380443500659',
    Identifier: 'Business name',
  },
}

const country = (process.env.REACT_APP_COUNTRY || 'ua').toLowerCase() as 'fr' | 'ua'
export const scalingConfig = scaling[country] ?? scaling.ua
export const COUNTRY = country
